import { modalHelpers } from "shared/lib/helpers/modalHelpers";

import { queryClient } from "@/api/query-client";
import {
  MOVE_TO_NURTURE_MODAL_ID,
  MoveToNurtureModal,
} from "@/components/modals/move-to-nurture-modal";
import { useAccountDetailsContext } from "@/modules/pipeline/account-details/context";
import { listWorkspaceQueryKeys } from "@/modules/list-workspace/queries/keys";
import { useListsStore } from "@/modules/list-workspace/store/lists-store";

export const ActionMoveToNurture = () => {
  const activeList = useListsStore((state) => state.activeList);
  const listViewId = useListsStore((state) => state.listViewId);
  const { contacts, campaign, account, onAccountUpdate, accountHistoryData } =
    useAccountDetailsContext();

  const openModal = () => {
    modalHelpers.open(MOVE_TO_NURTURE_MODAL_ID);
  };

  const reloadAccount = () => {
    onAccountUpdate();
    accountHistoryData.reloadData();

    // to update the list details - cold/nurture counts
    if (activeList?.id) {
      queryClient.invalidateQueries({
        queryKey: listWorkspaceQueryKeys.list(activeList?.id),
      });

      // to update the list view metadata - cold/nurture counts
      if (listViewId) {
        queryClient.invalidateQueries({
          queryKey: listWorkspaceQueryKeys.view(listViewId),
        });
      }
    }
  };

  return (
    <>
      <button className="ae-link brand-typography-body6" onClick={openModal}>
        Move to nurture
      </button>

      <MoveToNurtureModal
        contacts={contacts}
        campaign={campaign}
        account={account}
        onSuccess={reloadAccount}
      />
    </>
  );
};
